import { EchoManager } from "./echo-manager.js";

EchoManager.initialize();

export { EchoManager };
